export default {
  title: "Partners"
}